import { Component } from '@angular/core';

import { ButtonComponent } from '../../../shared/components/buttons/button.component';

@Component({
  selector: 'pin-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  imports: [ButtonComponent]
})
export class PrivacyPolicyComponent {
  private static readonly GOOGLE_ANALYTICS_URL = 'https://tools.google.com/dlpage/gaoptout/';
  private static readonly MAIL_TO_INTRAFI = 'mailto:CCPA@intrafi.com';


  openMailApp(): void {
    window.location.href = PrivacyPolicyComponent.MAIL_TO_INTRAFI;
  }

  openGoogleAnalyticsOptOut(): void {
    window.open(PrivacyPolicyComponent.GOOGLE_ANALYTICS_URL, '_blank');
  }
}
